import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isActingAs } from '../../auth/authUtils';

const CreatorRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.auth?.user || state.auth.user);

  // Delegated access — always allow (permissions enforced by PermissionRoute)
  if (isActingAs() || user?._acting_as) {
    return children;
  }

  const isCreator = user?.user_type === 'creator' || user?.user_type === 'admin' || user?.is_verified;

  if (!isCreator) {
    return <Navigate to="/become-creator" replace />;
  }

  return children;
};

export default CreatorRoute;
